import { makeVar } from '@apollo/client'
import { ApprovalDeal } from 'ts/interfaces/approvalDeal.interface'

export type PendingApprovalsState = {
  deals: ApprovalDeal[]
  didError?: boolean
  errorCode?: string
  errorMessage?: string
  infoMessage?: string
}

export const pendingApprovalsVar = makeVar<PendingApprovalsState>({ deals: [] })

export const setPendingApprovals = (state: PendingApprovalsState) => pendingApprovalsVar(state)

export const clearPendingApprovals = () => pendingApprovalsVar({ deals: [] })
